var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      class: _vm.type,
      attrs: { show: _vm.show, type: _vm.type },
      on: { close: _vm.close }
    },
    [
      _vm.title
        ? _c("header", [_c("h4", [_vm._v(_vm._s(_vm.title))])])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        { class: { long: _vm.long, left: _vm.alignLeft } },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("footer", [
        _c(
          "button",
          {
            on: {
              click: function($event) {
                return _vm.cancel()
              }
            }
          },
          [_vm._v(_vm._s(_vm.cancelLabel))]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "action",
            on: {
              click: function($event) {
                return _vm.confirm()
              }
            }
          },
          [_vm._v(_vm._s(_vm.confirmLabel))]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }